<template>
  <Breadcrumbs
      title="Create Route"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Routes', path: '/routes' },
      { label: 'Create Route', path: '/create-route' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <createRouteForm/>
    </div>
  </div>
</template>

<script>

import createRouteForm from "@/pages/master_data/routes/createRouteForm.vue";

export default {
  components: {
    createRouteForm
  }
}
</script>